export default function slidetoggle() {

  /* Slide Toggle 開閉
  ----------------------------------------------------------------- */
  // SPデバイス
  var spSwitch = window.matchMedia('(max-width: 768px)').matches;
  // Headerの高さ取得
  var headerHeight = $('header').outerHeight();
  // Slide Toggle
  var slideToggle = '.js-slideToggle';
  // Slide Toggle ボタン
  var slideToggleBtn = '.js-slideToggle__btn';
  // Slide Toggle 開閉
  var slideToggleOpen = '.js-slideToggle__open';
  // Slide Toggle 固定
  var slideToggleSticky = 'c-slideToggle__sticky';

  $(slideToggleOpen).hide();

  $(slideToggleBtn).click(function () {
    $(this).next(slideToggleOpen).slideToggle('slow').siblings(slideToggleOpen).slideUp(400);
    $(this).siblings(slideToggleBtn).removeClass('active');
    $(this).toggleClass('active');
  });

  if (spSwitch) {
    $(slideToggleOpen　 + ' ul li a').click(function () {
      $(slideToggleOpen).hide();
      $(slideToggleBtn).removeClass('active');
    });
  }

  /* Slide Toggle Fixed
  ----------------------------------------------------------------- */
  if (spSwitch) {
    var slideToggleScroll = $(slideToggle);
    var offset = slideToggleScroll.offset();
    var offsetTop = offset.top - headerHeight + 230;

    $(window).scroll(function () {
      if ($(window).scrollTop() > offsetTop) {
        slideToggleScroll.addClass(slideToggleSticky);
        setTimeout(function () {
          $('.js-anchor').addClass('c-anchor__sticky');
        }, 1000);
      } else {
        slideToggleScroll.removeClass(slideToggleSticky);
        setTimeout(function () {
          $('.js-anchor').removeClass('c-anchor__sticky');
        }, 1000);
      }
    });
  }

}